<template>
  <div>
    <base-header class="pb-6 content__title content__title--calendar">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" class="mt-3 mt-lg-0 text-lg-right">

          <a href="#" @click.prevent="prev" class="fullcalendar-btn-prev btn btn-sm btn-default">
            <i class="fas fa-angle-left"></i>
          </a>
          <a href="#" @click.prevent="next" class="fullcalendar-btn-next btn btn-sm btn-default">
            <i class="fas fa-angle-right"></i>
          </a>

          <base-button class="btn btn-sm btn-default" :class="{'active': defaultView === 'dayGridMonth'}" @click="changeView('dayGridMonth')">
            Mês
          </base-button>
          <base-button class="btn btn-sm btn-default" :class="{'active': defaultView === 'dayGridWeek'}" @click="changeView('dayGridWeek')">
            Semana
          </base-button>
          <base-button class="btn btn-sm btn-default" :class="{'active': defaultView === 'timeGridDay'}" @click="changeView('timeGridDay')">
            Dia
          </base-button>

        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <b-card no-body class="card-calendar">
            <b-card-body class="p-0 card-calendar-body">
              <full-calendar 
                :events="eventsCalendar"
                :plugins="calendarPlugins"
                contentHeight="auto"
                :theme="false"
                :selectable="true"
                :selectHelper="true"
                ref="fullCalendar"
                class="calendar"
                :defaultView="defaultView"
                @dateClick="onDateClick">
              </full-calendar>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <modal :show.sync="showDateClickedModal" size="lg" :showClose="true" :headerClasses="''">
      <template #header align-self="end">
        <h2 style="margin-right:10px;">
          {{  namesDay[new Date(clickedDate['selectedDate']).getUTCDay()] + ', ' +
              new Date(clickedDate['selectedDate']).toLocaleDateString('pt-BR',{timeZone: 'UTC'}) 
          }}
        </h2>

        <a href="#" @click.prevent="prevDay" class="fullcalendar-btn-prev btn btn-sm btn-default">
          <i class="fas fa-angle-left"></i>
        </a>
        <a href="#" @click.prevent="nextDay" class="fullcalendar-btn-next btn btn-sm btn-default">
          <i class="fas fa-angle-right"></i>
        </a>
      </template>
      
      <!--BODY-->
      <div v-if="clickedDate.length > 0">
        <b-card v-for="(click,idx) in clickedDate" :key="idx" :title="clickedDate[idx].name">
          <b-table :items="click" :fields="fieldsTableEvents" stickyColumn responsive small>

          <template #cell(size)="data">
            {{!data.value ? '-' : data.value + ' pax'}}
          </template>

          <template #cell(operation)="data">
            {{ data.value ? data.value : '' }}
            <b-button v-if="!data.value" variant="info" disabled size="sm">Criar</b-button>
          </template>

          </b-table>
        </b-card>
      </div>
      <div v-else>
        <b-row align-h="center">
          <b-card-title>
            Não há operações para a data 
            {{ new Date(clickedDate['selectedDate']).toLocaleDateString('pt-BR',{timeZone: 'UTC'}) }}
          </b-card-title>
        </b-row>
      </div>
      <!--END OF BODY-->

    </modal>

  </div>
</template>

<script>
import Modal from '@/components/Modal'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();
const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
"Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

const dayNames = ["Domingo", "Segunda-feira", "Terça-feira","Quarta-feira", 
"Quinta-feira", "Sexta-feira", "Sábado"];

export default {
    name: 'CalendarOperacao',

    components: {
      Modal,
      FullCalendar
    },

    props:{
      events:{ type:Array, default:[] },
    },

    computed:{
      year(){ return y; },
      namesMonth(){ return monthNames; },
      namesDay(){ return dayNames; }
    },

    watch:{
      events(novo,old){
        if(novo != old){ this.inspectEvents(); }
      }
    },

    data() {
      return {
          calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin], defaultView: 'dayGridMonth',
          month:new Date().getMonth(), day:new Date().getDate(),

          eventColors: ['bg-info', 'bg-orange', 'bg-red', 'bg-green', 'bg-default', 'bg-blue', 'bg-purple', 'bg-yellow'],
          eventsCalendar:[], showDateClickedModal:false, clickedDate:[],

          fieldsTableEvents:[
            {key: 'responsable', label:'Responsável'}, {key: 'size', label:'Tamanho'},
            {key: 'seller', label:'Vendedor'}, {key: 'operation', label:'Operação'}
          ],

          aray:[
              
          ]
      };
    },

    methods: {
      inspectEvents(){
          var campos = this.events.map(function(val,idx){
            var fields = JSON.parse(val.product_xfields);

            if('Subcategoria' in fields){
              return {
                categ:fields.Subcategoria.label, 
                category:fields.Subcategoria, 
                date: val.date, 
                amount: val.amount,
              };
            }
            else{ 
              return {
                categ:fields.Categoria.label, 
                category:fields.Categoria,
                date: val.date,
                amount: val.amount,
              }; 
            }
          });

          this.eventsCalendar = campos.map(function(val,idx){
              var color = '';
              if(val.categ == 'Balão'){ color = 'bg-blue'; }
              else if(val.categ == 'Roteiro'){ color = 'bg-red'; }
              else{ color= 'bg-green' }

              var obj = {
                title: val.categ + ': ' + val.amount + (val.amount > 1 ? ' grupos': ' grupo'),
                start: new Date(val.date).toISOString().split('T')[0],
                end: new Date(val.date).toISOString().split('T')[0],
                allDay:true,
                className: color,
              }
              return obj;
          })
      },

      calendarApi() { return this.$refs.fullCalendar.getApi(); },

      changeView(viewType) {
        this.defaultView = viewType
        this.calendarApi().changeView(viewType)
      },

      next(){ this.calendarApi().next(); },

      prev(){ this.calendarApi().prev(); },

      nextDay(){
        var dt = new Date(this.clickedDate['selectedDate']);

        //number of days in selectedDate month
        const daysInMonth = new Date(dt.getUTCFullYear(), dt.getUTCMonth(), 0).getUTCDate();

        //check if the current day of selected date is the last in the month of selected date
        if(daysInMonth == dt.getUTCDate()){
          dt.setUTCMonth(dt.getUTCMonth() + 1); 
          dt.setUTCDate(1);                     //backing to the future
          this.fetchOperations(dt);
        }
        else{   //not yet
          dt.setUTCDate(dt.getUTCDate() + 1); this.fetchOperations(dt); 
        }
      },

      prevDay(){
        var dt = new Date(this.clickedDate['selectedDate']);

        //number of days in selectedDate month
        const daysInMonth = new Date(dt.getUTCFullYear(), dt.getUTCMonth(), 0).getUTCDate();

        //check if the current day of selected date is the last in the month of selected date
        if(daysInMonth == dt.getUTCDate()){
          var dayBefore =new Date(dt); // current date
          dayBefore.setUTCDate(1); // going to 1st of the month
          dayBefore.setUTCHours(-1); // going to last hour before this date even started. backing to the past

          //it is the last day
          dt.setUTCMonth(dayBefore.getUTCMonth()); 
          dt.setUTCDate(dayBefore.getUTCDate());
          this.fetchOperations(dt);
        }
        else{   //not yet
          dt.setUTCDate(dt.getUTCDate() - 1); this.fetchOperations(dt); 
        }
      },

      onDateClick({el, date}) {
        this.fetchOperations(date)
      },

      fetchOperations(date){
        //DATE OBJECT TO yyyy-mm-dd
        var data = new Date(date).toISOString().split('T')[0];

        //Filtering events where date equals {{date}}, the selected day
        var eventosDoDia = this.events.filter(function(val,idx){
          const dt = new Date(val.date).toISOString().split('T')[0]
          if(dt == data){ return val; }
        });

        this.clickedDate = eventosDoDia.map(function(val,idx){
          //check if JSON.parse(val.booking_xfields).clients exists and return length or "-"
          var tam  = val.booking_xfields == null || val.booking_xfields ==undefined ? null : 
            JSON.parse(val.booking_xfields).clients != null && JSON.parse(val.booking_xfields).clients != undefined ?
              Object.keys(JSON.parse(val.booking_xfields).clients).length : null;

          return {
            responsable: val.client_name,
            size: tam == undefined ? null : tam,
            seller: val.bill_vendor_name,
            operation: val.booking_id==undefined ? null : parseInt(val.booking_id,10),
            name: val.product_name,
          };
        });

        //GROUPING OPERATIONS BY NAME
        this.clickedDate = this.groupBy(this.clickedDate, el => el.name)
        this.clickedDate = Array.from(this.clickedDate)

        //RETRIEVING NAME OF AGROUPED OPERATIONS
        this.clickedDate = this.clickedDate.map(function(val,idx){
          val[1].name = val[1][0].name
          return val[1]
        });

        this.clickedDate['selectedDate'] = data;

        this.showDateClickedModal = true;
      },

      //METHOD TO GROUP BY KEYGETTER.
      //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
      groupBy(list,keyGetter){
        const map = new Map();
        list.forEach((item) => {
          const key = keyGetter(item);
          const collection = map.get(key);
          if (!collection) {
            map.set(key, [item]);
          } 
          else {
            collection.push(item);
          }
        });
        return map;
      }

    },

    created(){
      this.inspectEvents();
    }

};
</script>

<style lang="scss">
  @import "~@fullcalendar/core/main.css";
  @import '~@fullcalendar/daygrid/main.css';
  @import '~@fullcalendar/timegrid/main.css';
  @import "~@/assets/sass/core/vendors/fullcalendar";
</style>